const visibilityStates = {
    default: {
      booking_id: false,
      booking_link: false,
      ready: false,
      bus_ready: false,
      guide_ready: false,
      activity_1_name: false,
      activity_1_time: false,
      activity_1_phone: false,
      activity_2_name: false,
      activity_2_time: false,
      activity_2_phone: false,
      __check__: false,
      color_choice: false,
      delete_action: false,
    },
    minimal: {
      booking_id: false,
      booking_link: false,
      __check__: false,
      ready: false,
      bus_ready: false,
      guide_ready: false,
      color_choice: false,
      driver_name: false,
      activity_1_name: false,
      activity_2_name: false,
      delete_action: false,
    },
    operational: {
      booking_id: false,
      booking_link: false,
      __check__: false,
      activity_1_name: false,
      activity_2_name: false,
      activity_1_time: false,
      activity_2_time: false,
      activity_1_phone: false,
      activity_2_phone: false,
      color_choice: false,
      comment: false,
      delete_action: false,
    },
    setUp: {
      id: false,
      booking_id: false,
      booking_link: false,
      parent_id: false,
      name: true,
      tour_code: false,
      time_from: true,
      time_to: false,
      actual_departure_time: false,
      actual_arrival_time: false,
      max_size: true,
      size: true,
      child_num: false,
      infant_num: false,
      escort: false,
      final_pax: false,
      park_spot: true,
      bus_sign: true,
      bus: false,
      bus_name: false,
      bus_size: true,
      driver: false,
      driver_phone: false,
      guide: false,
      guide_name: false,
      guide_phone: false,
      meal: false,
      activity_1: false,
      activity_1_name: false,
      activity_1_phone: false,
      activity_1_time: false,
      activity_2: false,
      activity_2_name: false,
      activity_2_phone: false,
      activity_2_time: false,
      ready: false,
      bus_ready: false,
      guide_ready: false,
      supplier_called: false,
      comment: true,
      delete_action: false,
      color_choice: false,
      created_date: false,
      last_modified: false,
      created_by: false,
      last_modified_by: false,
    },
  };

  export default visibilityStates;
